var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldPathSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.81 2C4.17 2 2 4.17 2 7.81v8.37C2 19.83 4.17 22 7.81 22h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2H7.81zm7.23 10.27.14 2.4c.13 1.34-.33 1.8-1.6 1.95l-5.07.6c-.22.03-.42.02-.61-.04l1.98-1.98c.29-.29.29-.77 0-1.06a.767.767 0 0 0-1.07 0l-1.576 1.584a.255.255 0 0 1-.434-.214l.59-5.07c.16-1.27.62-1.68 1.96-1.6l2.39.14 1.03-1.63c.47-.74 1.43-.78 2.13-.08l1.85 1.85c.66.65.62 1.68-.09 2.13l-1.62 1.02z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldPathSquare);
export default __webpack_public_path__ + "static/media/vuesax-bold-path-square.cb160978c0eaf463ed98074860c0e74e.svg";
export { ForwardRef as ReactComponent };